<template>
    <div>


        <h1 v-if="isSearching">{{headline}}</h1>
        <div v-else>
            <drop-down-header :items="categories" :callback="chooseCategory"/>
        </div>

        <blog-list-item v-for="blog in blogs" :key="blog._id" :blog="blog" />
        <loading-indicator name="blogs"/>

        <div v-if="nothingFound" class="text-center">
            <p>Sorry... we found nothing for "{{searchQuery}}"</p>
        </div>

    </div>
</template>

<script>

    import BlogListItem from './BlogListItem.vue';
    import LoadingIndicator from '../ui/LoadingIndicator.vue';
    import DropDownHeader from '../ui/DropDownHeader';

    export default {
        name: '',
        props: {
            headline: {type:String, default:'Latest Blogs'},
            searchQuery: {type:String, default: ''}
        },
        data() {
            return {
                isActive: false,
                search: null,
                wasLastBlog: false,
                itemsPerPage: 24,
                isLoading: false,
                categories: [
                    //{key: 'best', label: 'Best Blogs'},
                    {key: 'popular', label: 'Popular Blogs'},
                    {key: 'latest', label: 'Latest Blogs'},
                    {key: 'latestupdate', label: 'Latest Updates'}

                ],
                currentCategory: null,
                showCats: false,
                blogs: [],
                nothingFound: false
            }
        },
        computed: {
            isSearching(){
                return this.searchQuery.length>2
            }
        },
        watch:{
            searchQuery(newVal, oldVal){
                this.blogs = [];
                this.loadBlogs(0);
            }
        },
        created(){
            this.currentCategory = this.categories[0];
            document.addEventListener("scroll", this.scrollListener);
        },
        mounted() {
            this.isActive = true;
            this.$nextTick(()=>{
                if(!this.isSearching)this.loadBlogs(0);
            });
            this.$bus.$on('bloglist.exists', (data)=>{
              if(this.isActive) this.$bus.$emit('blog-modal.listExists', this.getNextPrevBlogs(data.currentBlog));
            });
        },
        beforeDestroy(){
            this.isActive = false;
            document.removeEventListener('scroll', this.scrollListener);
        },
        methods: {
            scrollListener(){
                let scrollPos = window.pageYOffset + window.innerHeight;
                if(!this.wasLastBlog && !this.isLoading && Math.abs(scrollPos - document.body.scrollHeight) < 50){
                    this.loadMore();
                }
            },
            loadBlogs(offset){
                this.nothingFound = false;
                if(this.isSearching){
                    this.$api.searchBlogs(this.searchQuery, offset).then((res)=>{
                        if(res.data.blogs.length < this.itemsPerPage) this.wasLastBlog = true;
                        res.data.blogs.forEach((blog)=>{
                            this.blogs.push(blog);
                        });
                        this.isLoading = false;
                        if(offset===0 && res.data.blogs.length===0){
                            this.nothingFound = true;
                        }
                    });
                } else {
                    this.$api.getBlogListByType(this.currentCategory.key, offset).then((res)=>{
                        if(res.data.blogs.length < this.itemsPerPage) this.wasLastBlog = true;
                        res.data.blogs.forEach((blog)=>{
                            this.blogs.push(blog);
                        });
                        this.isLoading = false;
                    });
                }

            },
            loadMore() {
              this.isLoading = true;
              this.loadBlogs(this.blogs.length);
            },
            chooseCategory(cat){
                this.showCats = false;
                if(cat != this.currentCategory){
                    this.currentCategory = cat;
                    this.blogs = [];
                    this.loadBlogs(0);
                }
            },
            getNextPrevBlogs(current){
              let last = null;
              let next = null;
              for(let i in this.blogs){
                if(i>this.blogs.length - 3 && !this.wasLastBlog) this.loadMore();
                const b = this.blogs[i];
                if(b === current){
                  next = 1;
                  continue;
                }
                if(next === 1){
                  next = b;
                  break;
                }
                last = b;
              }
              if(next === 1) next = null;
              return {
                nextBlog: next,
                prevBlog: last
              }
            }
        },
        components:{
            BlogListItem,
            LoadingIndicator,
            DropDownHeader
        }
    }
</script>

<style lang="sass" scoped>


</style>



// WEBPACK FOOTER //
// src/components/blogs/BlogList.vue